import React from "react";

import {MuiIcon, MuiIconExternalProps} from "../MuiIcon";

export const NumberListIcon = React.forwardRef<HTMLElement, MuiIconExternalProps>(
    (props: MuiIconExternalProps, ref) => {
        return (
            <MuiIcon {...props}
                     ref={ref}
            >{'\ue242'}</MuiIcon>
        );
    })